
const Indicator = ({ product, currentIndex, setCurrentIndex }) => {
    return <div className="buttonArea">
        {product?.images.map((image, index) => {
            return <div className='btnIndicator' key={index} onClick={() => { setCurrentIndex(index); }} onTouchStart={() => { setCurrentIndex(index); }}>
                <button className={currentIndex === index ? 'active' : ''}>
                </button>
            </div>
        })}
    </div>
}
export default Indicator;